export const MOBILE_FULL_SCREEN_MODAL_Z = 11000;
export const MODAL_ABOVE_FULL_SCREEN_Z = MOBILE_FULL_SCREEN_MODAL_Z + 100;
export const PORTAL_POPOVER_Z = MODAL_ABOVE_FULL_SCREEN_Z + 50;
